module.exports = __webpack_public_path__ + "img/image00013-14.f7965019.jpg";